<mat-card class="mat-card-element-force-relative">
  <div class="title-container">
    <button mat-icon-button (click)="onBackButtonClick()" color="primary">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <mat-card-title>Settings</mat-card-title>
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onResetClick()">
        <mat-icon>restore_page</mat-icon>
        <span>Reset Settings</span>
      </button>
      <button mat-menu-item (click)="onBackupClick()">
        <mat-icon>cloud_download</mat-icon>
        <span>Backup To File</span>
      </button>
      <button mat-menu-item (click)="uploader.click()">
        <mat-icon>settings_backup_restore</mat-icon>
        <span>Restore From File</span>
      </button>
      <input hidden="hidden" type="file" #uploader accept=".json" (change)="onBrowseFiles($event)" />
    </mat-menu>
  </div>

  <form [formGroup]="form" class="settings-form vertical-layout">
    <mat-accordion multi="false">
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title> General </mat-panel-title>
          <mat-panel-description>
            &nbsp;
            <mat-icon [ngClass]="['menu-icon-sizing', 'menu-icon-padding']" fontSet="material-icons-outlined">library_books</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-form-field appearance="outline" [ngClass]="['mat-form-field-force-relative']">
          <mat-label>Base URL</mat-label>
          <input matInput formControlName="baseUrl" placeholder="https://prod.firsttofile.com/YourInstance/" />
          <mat-hint> Hint: This is the base URL for the First to File Instance e.g.,<br />https://prod.firsttofile.com/instance/ </mat-hint>
          @if (form.controls['baseUrl'].hasError('notApi')) {
            <mat-error>
              The URL entered does not appear to lead to a valid First to File API. Attempts to communicate with {{ parsedUrl() }}api/ did
              not return successful. If you believe this to be in error, please contact your support team.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="no-subscript">
          <mat-label>Default IP Type</mat-label>
          <mat-select #type formControlName="ipTypeDefault" class="fitcontent">
            <mat-select-trigger>
              @if (type.value !== 'All') {
                <ip-icon [ipType]="type.value"></ip-icon>
              }
              {{ getFilteredIpTypes() }}
            </mat-select-trigger>
            <mat-option value="All">All</mat-option>
            @for (type of ipTypes; track type; let i = $index) {
              <mat-option [value]="type.key" [attr.data-index]="i">
                <div class="option-content"><ip-icon [ipType]="ipTypes[i].key"></ip-icon>{{ type.value }}</div>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div>
          <mat-checkbox class="compact-checkbox" formControlName="navigationBarUploadOption" title="Navigation Bar Upload Option"
            >Navigation Bar Upload Option</mat-checkbox
          >
          @if (form.get('navigationBarUploadOption')?.value) {
            <mat-form-field appearance="outline" class="indented-dropdown no-subscript">
              <mat-label>Default IP Type</mat-label>
              <mat-select class="fitcontent" formControlName="defaultIpTypeUploadBar">
                @for (action of defaultIpTypesUploadBar | keyvalue; track action) {
                  <mat-option [value]="action.key">
                    {{ action.value }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
        <div>
          <mat-checkbox class="compact-checkbox" formControlName="regExpActive" title="Use Saved Regular Expression"> </mat-checkbox>
          <a href="#" (click)="openRegExpDialog()" class="case-number-matching" title="Open the Regular Expression dialog"
            >Case Number Matching</a
          >
        </div>
        <div>
          <mat-checkbox class="compact-checkbox" formControlName="appNumberMatchingEnabled" title="Enable Application Number Matching">
          </mat-checkbox>
          <span>Application Number Matching</span>
        </div>
        <div>
          <mat-checkbox class="compact-checkbox" formControlName="autoRenameDuplicateFiles" title="Auto-rename duplicate files"
            >Auto-rename duplicate files</mat-checkbox
          >
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Document Preferences</mat-panel-title>
          <mat-panel-description>&nbsp;<ip-icon ipType="Reference"></ip-icon></mat-panel-description>
        </mat-expansion-panel-header>
        <div class="form-fields-container">
          <mat-form-field appearance="outline">
            <mat-label>Document Icon Action</mat-label>
            <mat-select class="fitcontent" formControlName="trifoldDocumentIconAction">
              @for (action of documentActions | keyvalue; track action) {
                <mat-option [value]="action.key">
                  {{ action.value }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Document Text Action</mat-label>
            <mat-select class="fitcontent" formControlName="trifoldDocumentTextAction">
              @for (action of documentActions | keyvalue; track action) {
                <mat-option [value]="action.key">
                  {{ action.value }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Patent Case Preferences </mat-panel-title>
          <mat-panel-description>&nbsp;<ip-icon ipType="Patent"></ip-icon></mat-panel-description>
        </mat-expansion-panel-header>
        <mat-form-field appearance="outline">
          <mat-label>Default View</mat-label>
          <mat-select class="fitcontent" formControlName="patentDefaultView">
            @for (view of defaultViewOptions; track view) {
              <mat-option [value]="view.key">
                {{ view.value }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (trifoldMap.Patent; as tri) {
          <mat-form-field appearance="outline">
            <mat-label>Default Trifold Option</mat-label>
            <mat-select class="fitcontent" formControlName="trifoldPatentDefault">
              @for (opt of tri | keyvalue; track opt) {
                <mat-option [value]="opt.key">
                  <div class="option-content">{{ opt.value.label }}</div>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <mat-form-field appearance="outline">
          <mat-label>Default Details Option</mat-label>
          <mat-select class="fitcontent" formControlName="patentDefaultTab">
            @for (tab of patentDefaultTabOptions; track tab) {
              <mat-option [value]="tab.key">
                {{ tab.value }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div class="details-option-container">
          <mat-form-field appearance="outline">
            <mat-label>Primary Sub-Type</mat-label>
            <mat-select class="fitcontent" formControlName="patentParentSubType">
              @if (patentDocumentSubtypes.length === 0) {
                <mat-option [disabled]="true">Please Login First</mat-option>
              } @else {
                <mat-option value=""></mat-option>
              }
              @for (dt of patentDocumentSubtypes; track dt) {
                <mat-option [value]="dt.id">{{ dt.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (this.form.get('patentParentSubType')?.value) {
            <div class="help-icon">
              <mat-icon
                class="help-icon"
                matTooltip="An administrative setting in First To File may affect expected default trifold selections. See your First To File administrator for further information."
              >
                help_outline
              </mat-icon>
            </div>
          }
        </div>
        @if (isOutlookOrNotOffice) {
          <div class="details-option-container">
            <mat-form-field appearance="outline">
              <mat-label>Attachments Sub-Type</mat-label>
              <mat-select class="fitcontent" formControlName="patentAttachSubType">
                @if (patentDocumentSubtypes.length === 0) {
                  <mat-option [disabled]="true">Please Login First</mat-option>
                } @else {
                  <mat-option value=""></mat-option>
                }
                @for (dt of patentDocumentSubtypes; track dt) {
                  <mat-option [value]="dt.id">{{ dt.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (this.form.get('patentAttachSubType')?.value) {
              <div class="help-icon">
                <mat-icon
                  class="help-icon"
                  matTooltip="An administrative setting in First To File may affect expected default trifold selections. See your First To File administrator for further information."
                  >help_outline</mat-icon
                >
              </div>
            }
          </div>
        }

        <div class="sort-preferences-container">
          <app-sorting formControlName="patentSortSettings"></app-sorting>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Trademark Preferences </mat-panel-title>
          <mat-panel-description>&nbsp;<ip-icon ipType="Trademark"></ip-icon></mat-panel-description>
        </mat-expansion-panel-header>
        <mat-form-field appearance="outline">
          <mat-label>Default View</mat-label>
          <mat-select class="fitcontent" formControlName="trademarkDefaultView">
            @for (view of defaultViewOptions; track view) {
              <mat-option [value]="view.key">
                {{ view.value }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (trifoldMap.Trademark; as tri) {
          <mat-form-field appearance="outline">
            <mat-label>Default Trifold Option</mat-label>
            <mat-select class="fitcontent" formControlName="trifoldTrademarkDefault">
              @for (opt of tri | keyvalue; track opt) {
                <mat-option [value]="opt.key">
                  <div class="option-content">{{ opt.value.label }}</div>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <mat-form-field appearance="outline">
          <mat-label>Default Details Option</mat-label>
          <mat-select class="fitcontent" formControlName="trademarkDefaultTab">
            @for (tab of trademarkDefaultTabOptions; track tab) {
              <mat-option [value]="tab.key">
                {{ tab.value }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div class="details-option-container">
          <mat-form-field appearance="outline">
            <mat-label>Primary Sub-Type</mat-label>
            <mat-select class="fitcontent" formControlName="trademarkParentSubType">
              @if (trademarkDocumentSubtypes.length === 0) {
                <mat-option [disabled]="true">Please Login First</mat-option>
              } @else {
                <mat-option value=""></mat-option>
              }
              @for (dt of trademarkDocumentSubtypes; track dt) {
                <mat-option [value]="dt.id">{{ dt.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (this.form.get('trademarkParentSubType')?.value) {
            <div class="help-icon">
              <mat-icon
                class="help-icon"
                matTooltip="An administrative setting in First To File may affect expected default trifold selections. See your First To File administrator for further information."
                >help_outline</mat-icon
              >
            </div>
          }
        </div>
        @if (isOutlookOrNotOffice) {
          <div class="details-option-container">
            <mat-form-field appearance="outline">
              <mat-label>Attachments Sub-Type</mat-label>
              <mat-select class="fitcontent" formControlName="trademarkAttachSubType">
                @if (trademarkDocumentSubtypes.length === 0) {
                  <mat-option [disabled]="true">Please Login First</mat-option>
                } @else {
                  <mat-option value=""></mat-option>
                }
                @for (dt of trademarkDocumentSubtypes; track dt) {
                  <mat-option [value]="dt.id">{{ dt.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (this.form.get('trademarkAttachSubType')?.value) {
              <div class="help-icon">
                <mat-icon
                  class="help-icon"
                  matTooltip="An administrative setting in First To File may affect expected default trifold selections. See your First To File administrator for further information."
                  >help_outline</mat-icon
                >
              </div>
            }
          </div>
        }
        <div class="sort-preferences-container">
          <app-sorting formControlName="trademarkSortSettings"></app-sorting>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Matter Preferences </mat-panel-title>
          <mat-panel-description>&nbsp;<ip-icon ipType="Matter"></ip-icon></mat-panel-description>
        </mat-expansion-panel-header>
        <mat-form-field appearance="outline">
          <mat-label>Default View</mat-label>
          <mat-select class="fitcontent" formControlName="matterDefaultView">
            @for (view of defaultViewOptions; track view) {
              <mat-option [value]="view.key">
                {{ view.value }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (trifoldMap.Matter; as tri) {
          <mat-form-field appearance="outline">
            <mat-label>Default Trifold Option</mat-label>
            <mat-select class="fitcontent" formControlName="trifoldMatterDefault">
              @for (opt of tri | keyvalue; track opt) {
                <mat-option [value]="opt.key">
                  <div class="option-content">{{ opt.value.label }}</div>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <mat-form-field appearance="outline">
          <mat-label>Default Details Option</mat-label>
          <mat-select class="fitcontent" formControlName="matterDefaultTab">
            @for (tab of matterDefaultTabOptions; track tab) {
              <mat-option [value]="tab.key">
                {{ tab.value }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div class="details-option-container">
          <mat-form-field appearance="outline">
            <mat-label>Primary Sub-Type</mat-label>
            <mat-select class="fitcontent" formControlName="matterParentSubType">
              @if (matterDocumentSubtypes.length === 0) {
                <mat-option [disabled]="true">Please Login First</mat-option>
              } @else {
                <mat-option value=""></mat-option>
              }
              @for (dt of matterDocumentSubtypes; track dt) {
                <mat-option [value]="dt.id">{{ dt.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (this.form.get('matterParentSubType')?.value) {
            <div class="help-icon">
              <mat-icon
                class="help-icon"
                matTooltip="An administrative setting in First To File may affect expected default trifold selections. See your First To File administrator for further information."
                >help_outline</mat-icon
              >
            </div>
          }
        </div>
        @if (isOutlookOrNotOffice) {
          <div class="details-option-container">
            <mat-form-field appearance="outline">
              <mat-label>Attachments Sub-Type</mat-label>
              <mat-select class="fitcontent" formControlName="matterAttachSubType">
                @if (matterDocumentSubtypes.length === 0) {
                  <mat-option [disabled]="true">Please Login First</mat-option>
                } @else {
                  <mat-option value=""></mat-option>
                }
                @for (dt of matterDocumentSubtypes; track dt) {
                  <mat-option [value]="dt.id">{{ dt.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (this.form.get('matterAttachSubType')?.value) {
              <div class="help-icon">
                <mat-icon
                  class="help-icon"
                  matTooltip="An administrative setting in First To File may affect expected default trifold selections. See your First To File administrator for further information."
                  >help_outline</mat-icon
                >
              </div>
            }
          </div>
        }
        <div class="sort-preferences-container">
          <app-sorting formControlName="matterSortSettings"></app-sorting>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Upload Preferences</mat-panel-title>
          <mat-panel-description>
            &nbsp;
            <mat-icon [ngClass]="['menu-icon-sizing', 'menu-icon-padding']" fontSet="material-icons-outlined">file_upload</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
        @if (uploadSubTypeGroupingMode) {
          <mat-form-field appearance="outline">
            <mat-label>Default Type/Sub Type</mat-label>
            <mat-select class="fitcontent" formControlName="uploadSubTypeGroupingMode">
              @for (groupModel of uploadSubTypeGroupingMode | keyvalue; track groupModel) {
                <mat-option [value]="groupModel.value">
                  {{ groupModel.value }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <div>
          <mat-checkbox formControlName="markAllAttachmentsForUpload" title="Mark all attachments for upload in selected emails"
            >Mark all attachments for upload in selected emails</mat-checkbox
          >
        </div>
        <div>
          <mat-checkbox formControlName="markAllEmbeddedImagesForUpload" title="Mark all embedded images for upload in selected emails"
            >Mark all embedded images for upload in selected emails</mat-checkbox
          >
        </div>
        <div>
          <mat-checkbox formControlName="includeFileExtension" title="Include file extension in Title"
            >Include file extension in Title</mat-checkbox
          >
        </div>
        <div>
          <mat-checkbox formControlName="markAsUrgent" title="Mark as Urgent by default">Mark as Urgent by default</mat-checkbox>
        </div>
        <div>
          <mat-checkbox formControlName="autoTruncateFileName" title="Auto-truncate file names">Auto-truncate file names</mat-checkbox>
        </div>
         <div>
          <mat-checkbox formControlName="autoTruncateTitleName" title="Auto-truncate title names">Auto-truncate title names</mat-checkbox>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </form>

  <mat-card-actions>
    <button mat-flat-button color="primary" (click)="onResetClick()">Reset</button>
    <button [disabled]="!form.valid" mat-flat-button color="primary" (click)="onSaveClick()">Save</button>
  </mat-card-actions>
</mat-card>
